/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Teasers {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { Section } from "@bw/bits"
import { Teasers as TeasersModule } from "@bw/modules"
import { NewsTeaser } from "@bw/partials"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const TeasersLatest = props => {
  const data = useStaticQuery(graphql`
    query LatestItemsInCollection {
      pages: allCollectionPages(limit: 50) {
        nodes {
          title
          slug
          teaserImage {
            localImage {
              childImageSharp {
                gatsbyImageData(width: 400, height: 300)
              }
            }
          }
        }
      }
      articles: allCollectionArticles(limit: 50) {
        nodes {
          title
          slug
          teaserImage {
            localImage {
              childImageSharp {
                gatsbyImageData(width: 400, height: 300)
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Section
      suptitle={props.suptitle}
      title={props.title}
      subtitle={props.subtitle}
    >
      <TeasersModule>
        {data.pages.nodes.map(item => {
          return (
            <NewsTeaser
              title={item.title}
              image={
                <GatsbyImage
                  image={getImage(item.teaserImage?.localImage)}
                  alt={item.title}
                />
              }
              to={`/${item.slug}/`}
            />
          )
        })}
      </TeasersModule>
    </Section>
  )
}

export default TeasersLatest

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on TeasersLatestModule {
 *   ...TeasersLatestModuleFragment
 * }
 *
 * This is also what you will get in the props of your {{pascalCase name}}
 * resolver component.
 */
export const query = graphql`
  fragment TeasersLatestModuleFragment on TeasersLatestModule {
    isExternal
    linkText
    linkType
    entry {
      slug
    }
    url
    composition
    maxItems
    teaserType
    displayType
    itemMobileDisplay
    numberOfColumns
  }
`
